import axios from 'axios'
import { BASE_URL } from '../../constants/urls'
import { api } from './interceptor'

const postApi = (data, path) => {
	return api.post(BASE_URL + path, {
		'x-platform': 'web',
		...data,
	})
}

const postApiWithToken = (data, token, path) => {
	return api.post(BASE_URL + path, data, {
		headers: {
			'x-auth-token': token,
		},
	})
}

export { postApi, postApiWithToken }
